import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Pages/Home';
import VolleyballCamps2 from './Pages/VolleyballCamps2';
import VolleyballTryouts from './Pages/VolleyballTryouts';
import BasketballCamps from './Pages/BasketballCamps';
import BasketballRates from './Pages/BasketballRates';
import Leadership from './Pages/Leadership';
import Highlights from './Components/Highlights';
import Foundation from './Pages/Foundation';
import EventCalendar from './Pages/EventCalendar';
import CourtRentals from './Pages/CourtRentals';
import Basketball from './Pages/Basketball';
import Complex from './Pages/Complex';
import ClinicsOpenGym from './Pages/ClinicsOpenGym';
import VolleyballCoaches from './Pages/VolleyballCoaches';
import TitansAcademy from './Pages/TitansAcademy';
import VolleyballTourneys from './Pages/VolleyballTourneys';
import AboutTitans from './Pages/AboutTitans';
import TitansEducation from './Pages/TitansEducation';
import TitansHousing from './Pages/TitansHousing';
import TitansRecruitment from './Pages/TitansRecruitment';
import Thanksgiving from './Pages/Thanksgiving';
import Advertise from './Pages/Advertise';
import ElevenElite from './Pages/ElevenElite';
import FifteenPremier from './Pages/FifteenPremier';
import SixteenElite from './Pages/SixteenElite';
import Volleyball3 from './Pages/Volleyball3';
import EventBooking from './Pages/EventBooking';
import FlagFootball from './Pages/FlagFootball';
import ScrollToTop from './Components/ScrollToTop';
import ScrollToHash from './Components/ScrollToHash';
import TrainRentalPricing from './Components/TrainRentalPricing';
import TermsConditions from './Pages/TermsConditions';
import PrivacyPolicy from './Pages/PrivacyPolicy';

function App() {
  return (
    <>
      <ScrollToTop />
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Volleyball" element={<Volleyball3 />} />
        <Route path="/VolleyballCamps2" element={<VolleyballCamps2 />} />
        <Route path="/VolleyballTryouts" element={<VolleyballTryouts />} />
        <Route path="/BasketballCamps" element={<BasketballCamps />} />
        <Route path="/BasketballRates" element={<BasketballRates />} />
        <Route path="/Leadership" element={<Leadership />} />
        <Route path="/Highlights" element={<Highlights />} />
        <Route path="/Foundation" element={<Foundation />} />
        <Route path="/EventCalendar" element={<EventCalendar />} />
        <Route path="/CourtRentals" element={<CourtRentals />} />
        <Route path="/Basketball" element={<Basketball />} />
        <Route path="/Complex" element={<Complex />} />
        <Route path="/ClinicsOpenGym" element={<ClinicsOpenGym />} />
        <Route path="/VolleyballCoaches" element={<VolleyballCoaches />} />
        <Route path="/Titansacademy" element={<TitansAcademy />} />
        <Route path="/VolleyballTourneys" element={<VolleyballTourneys />} />
        <Route path="/AboutTitans" element={<AboutTitans />} />
        <Route path="/TitansEducation" element={<TitansEducation />} />
        <Route path="/TitansHousing" element={<TitansHousing />} />
        <Route path="/TitansRecruitment" element={<TitansRecruitment />} />
        <Route path="/Thanksgiving" element={<Thanksgiving />} />
        <Route path="/Advertise" element={<Advertise />} />
        <Route path="/ElevenElite" element={<ElevenElite />} />
        <Route path="/FifteenPremier" element={<FifteenPremier />} />
        <Route path="/SixteenElite" element={<SixteenElite />} />
        <Route path="/BookEvent" element={<EventBooking />} />
        <Route path="/FlagFootball" element={<FlagFootball />} />
        <Route path="/TrainCarsRental" element={<TrainRentalPricing />} />
        <Route path="/TermsConditions" element={<TermsConditions />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
      </Routes>
    </>
  );
}

export default App;